// <reference types="googlemaps" />
import { Component, Input, OnInit, ViewChild, NgZone, ElementRef, Output, EventEmitter } from '@angular/core';
import gql from 'graphql-tag';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ValidadoresService } from 'src/app/shared/validadores/validadores';
import { TipoMensaje } from 'src/Wheel.Styles.HighVolume/Mensaje';
import { NotificacionGenerica } from 'src/Wheel.Styles.HighVolume/Notificacion';
import { comuna } from 'src/app/shared/object/comuna.model';
import { region } from 'src/app/shared/object/region.model';
import { territorio } from 'src/app/shared/object/territorio.model';
import { vendedor } from 'src/app/shared/object/vendedor.model';
import { ruta } from 'src/app/shared/object/ruta.model';
import { cliente_proveedor } from 'src/app/shared/object/cliente_proveedor.model';
import { bloqueo_historico } from 'src/app/shared/object/bloqueo_historico.model';
import { vendedor_rubro_cliente } from 'src/app/shared/object/vendedor_rubro_cliente.model';
import { ipt_vendedor_cliente } from 'src/app/shared/object/ipt_vendedor_cliente.model';
import { cliente_vendedor_rubro_IPT } from 'src/app/shared/object/cliente_vendedor_rubro_IPT.model';
import { rubro } from 'src/app/shared/object/rubro.model';
import { direccion } from 'src/app/shared/object/direccion.model';
import { maquinaJoin } from 'src/app/shared/object/maquina_join.model';
import { FormGroup, Validators, FormControl, FormBuilder } from '@angular/forms';
import { O_NOFOLLOW } from 'constants';
import { MapsAPILoader, MouseEvent, AgmCoreModule } from '@agm/core';
import { constants } from 'fs';
import { condicion_pago } from 'src/app/shared/object/condicion_pago.model';
import { RutValidator } from 'ng9-rut';
import { RutService } from 'src/app/shared/services/rut.service';
import { ToastService } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { Observable } from 'rxjs';
import { ClienteProveedorService } from 'src/app/services/cliente-proveedor.service';
import { debounceTime, filter } from 'rxjs/operators';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import * as _ from 'lodash';
import { RubroVendedorService } from 'src/app/services/rubro-vendedor.service';
import { EmpresaAlternaSavoryService } from 'src/app/services/empresa_alterna_savory.service';
import { DireccionService } from 'src/app/services/direccion.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { unidad_negocio } from 'src/app/shared/object/unidad_negocio.model';
import { ClientesService } from 'src/app/services/clientes.service';
import { MANTENEDOR_CLIENTES_MODULO, OP_EDICION_DIRECCIONES } from '../cliente-mantenedor.constants';

interface cliente_vendedor_rubro_IPTFixed extends cliente_vendedor_rubro_IPT {
  rubros: any[];
  rubrosVisibles: boolean;
  unidad_negocio_codigo: Array<any>;
}

@Component({
  selector: 'app-mantenedor-clientes-modal-direcciones',
  templateUrl: './modal-direcciones.component.html',
  styleUrls: ['../clientes.component.scss'],
  providers: [SecurityService, ValidadoresService],
})
export class MantenedorClientesModalDireccionesComponent implements OnInit {
  @Input() permiteUnidadNegocio: boolean = false;
  @Input() optionsUnidadesDeNegocio: unidad_negocio[] = [];
  // Outputs
  @Output() onSuccess: EventEmitter<void> = new EventEmitter<void>();

  private client: GraphQLClient = null;

  mode: 'ADD' | 'EDIT';

  // check casa matriz o direccion
  readonly RB_CASAMATRIZ_: boolean = true;
  readonly RB_DIRECCION_ACT: boolean = false;

  // Modales
  @ViewChild('direcciones', { static: true }) editarModalDtoDireccion: ModalDirective;
  @ViewChild('agregarDireccion', { static: true }) agregarDireccion: ModalDirective;

  @ViewChild('direccionFormEdita', { static: false })
  public searchElementRefEdita: ElementRef;

  // Forms
  public formDatosDirecciones: FormGroup;

  // Data & Tmp
  public rutEmpresa: number;
  public sucursalEmpresa: number;
  public codigoModulo: number;
  public rutUsuario: number;
  public rutCliente: number;
  public nombreCliente: String;
  public direccionCliente: number;
  public itemDireccion: direccion;
  paginationContext: PaginationContext = new PaginationContext();

  optionsRubro: Array<any> = [];
  optionsDireccion: Array<any> = [];
  optionsVendedor: Array<any> = [];
  optionsFiltroComuna: Array<any> = [];
  optionsDatosDireccionAgregarComuna: Array<any> = [];
  optionsRegion: Array<any> = [];
  optionsTerritorioDireccion: Array<any> = [];
  optionsRutaDireccion: Array<any> = [];
  optionsEmpresaAlterna: Array<any> = [];

  public rutClienteFormateado: string;
  public filtroDireccionNombre: string;
  public filtroDireccionDireccion: string;
  public filtroPrincipalDireccionCliente = '';

  public zoom: number;
  public latitude: number;
  public longitude: number;
  private geoCoder;
  public address: string;

  public paginaActualDirecciones: number;
  public totalRegistrosDirecciones: number;
  public totalPaginasDirecciones: number;

  public listaDirecciones: direccion[];
  listaDireccionesAll: Array<any> = null;

  public listaDireccionesCombo: direccion[];
  public listaVendedor: vendedor[];
  public listaComunasFiltro: comuna[];
  public listaRegiones: region[];
  public listaTerritoriosDireccion: territorio[];
  public listaRutasDireccion: ruta[];
  public listaClienteVendedorRubroIPT: Array<any> = [];
  listaClienteVendedorRubroIPTFixed: cliente_vendedor_rubro_IPTFixed[];
  public listaIPTVendedorCliente: ipt_vendedor_cliente[];
  public listaVendedorRubroCliente: vendedor_rubro_cliente[];
  public listaVendedorUnidadNegocio: Array<any> = [];
  public listaRubros: rubro[];

  // Utils
  private log: any;
  ShowLongLat = false;
  long: number = 0;
  lat: number = 0;
  disableAddVendedor: boolean = false;
  HidenEmpresaHeredada: boolean;
  ObjectDirecc: direccion;
  checkbox1Checked: boolean = false;
  comunaCodigo: number = 0;

  /** Edición de direcciones (operación 9); la grilla se ve con solo consulta al mantenedor. */
  public puedeEditarDirecciones = false;

  constructor(
    client: GraphQLClient,
    private clientesService: ClientesService,
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    public validadores: ValidadoresService,
    public rutService: RutService,
    public toastService: ToastService,
    private messageRendererService: MessageRendererService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private ngZone: NgZone,
    private mapsAPILoader: MapsAPILoader,
    private rubroVendedorService: RubroVendedorService,
    private empresaAlternaSavoryService: EmpresaAlternaSavoryService,
    private direccionService: DireccionService
  ) {
    this.log = this.clog.log('MODAL-DIRECCIONES');
    this.client = client;

    this.formDatosDirecciones = this.createForms();
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo());
    this.codigoModulo = 1;
    this.rutUsuario = Number(this.accesolocalstorage.getRutUsuario());
    this.paginationContext.RecordsByPage = 10;

    this.paginaActualDirecciones = 1;
    this.totalPaginasDirecciones = 1;
    this.totalRegistrosDirecciones = 0;
    this.zoom = 16;

    this.loadInitialMapsData();

    this.loadComboRubros();

    this.formChangesSubscriptions();

    this.loadEmpesaAlterna();

    this.obtenerDatosVendedores();

    this.obtenerDatosComunas();

    this.obtenerDatosRegion();

    this.obtenerDatosTerritorio();

    this.obtenerDatosRuta();
  }

  loadEmpesaAlterna() {
    const inputParams = {
      codigo_comuna: this.comunaCodigo,
      paginaActual: 1,
      cantidadRegistrosPorPagina: 1,
    };

    this.empresaAlternaSavoryService.obtenerSegunFiltro(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      const { registros } = respuesta;
      this.optionsEmpresaAlterna = registros.map((emp) => ({ value: emp.idempalt, label: emp.detalle, ...emp }));
      this.formValidatorsService.selectFirstOrDefault(this.formDatosDirecciones.get('EmpresaAlteSel'), this.optionsEmpresaAlterna);
    });
  }

  loadComboRubros() {
    const self = this; // this is unused

    this.client.query(
      {
        query: gql`
          query ($rutEmpresa: Decimal) {
            rubro {
              obtenerRubros(empresa_rut: $rutEmpresa) {
                respuesta {
                  registros {
                    codigo
                    descripcion
                  }
                }
              }
            }
          }
        `,
        variables: {
          rutEmpresa: this.rutEmpresa,
        },
        fetchPolicy: 'no-cache',
      },
      function (respuesta) {
        self.listaRubros = respuesta.data.rubro.obtenerRubros.respuesta.registros;
        self.optionsRubro = [];
        let sel: any;
        self.listaRubros.forEach((element) => {
          sel = { value: element.codigo, label: element.descripcion };
          self.optionsRubro.push(sel);
        });
      }
    );
  }

  obtenerDatosVendedores() {
    const self = this; // this is unused
    // const regionSeleccionada = this.formAgregaDatosDirecciones.get('region')
    //   .value;

    this.client.query(
      {
        query: gql`
          query ($rutEmpresa: Decimal, $sucursalCodigo: Decimal) {
            vendedor {
              obtenerSegunFiltro(filtro: { exacto: { rut_empresa: $rutEmpresa, sucursal_codigo: $sucursalCodigo, tipobusqueda: 1 } }) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  registros {
                    codigo
                    nombre
                  }
                }
              }
            }
          }
        `,
        variables: {
          rutEmpresa: this.rutEmpresa,
          sucursalCodigo: this.sucursalEmpresa,
        },
        fetchPolicy: 'no-cache',
      },
      function (respuesta) {
        self.listaVendedor = respuesta.data.vendedor.obtenerSegunFiltro.respuesta.registros;
        self.optionsVendedor = [];
        let sel: any;
        self.listaVendedor.forEach((element) => {
          sel = { value: element.codigo, label: element.nombre };
          self.optionsVendedor.push(sel);
        });
      }
    );
  }

  obtenerDatosComunas() {
    const self = this; // this is unused

    this.client.query(
      {
        query: gql`
          query {
            comuna {
              obtenerSegunFiltro(filtro: { exacto: { codigo: -1, provincia_codigo: -1, nombre: "", codigo_region: -1 } }) {
                respuesta {
                  registros {
                    codigo
                    nombre
                    provincia_codigo
                  }
                }
              }
            }
          }
        `,
        fetchPolicy: 'no-cache',
      },
      function (respuesta) {
        self.listaComunasFiltro = respuesta.data.comuna.obtenerSegunFiltro.respuesta.registros;
        self.optionsFiltroComuna = [];
        self.optionsDatosDireccionAgregarComuna = [];
        let sel: any;
        self.listaComunasFiltro.forEach((element) => {
          sel = { value: element.codigo, label: element.nombre };
          self.optionsFiltroComuna.push(sel);
          self.optionsDatosDireccionAgregarComuna.push(sel);
        });
      }
    );
  }

  obtenerDatosRegion() {
    const self = this; // this is unused

    this.client.query(
      {
        query: gql`
          query {
            region {
              obtenerTodos {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  registros {
                    codigo
                    nombre
                  }
                }
              }
            }
          }
        `,
        fetchPolicy: 'no-cache',
      },
      function (respuesta) {
        self.listaRegiones = respuesta.data.region.obtenerTodos.respuesta.registros;
        self.optionsRegion = [];
        let sel: any;
        self.listaRegiones.forEach((element) => {
          sel = { value: element.codigo, label: element.nombre };
          self.optionsRegion.push(sel);
        });
      }
    );
  }

  obtenerDatosTerritorio() {
    const self = this; // this is unused

    this.client.query(
      {
        query: gql`
          query ($rutEmpresa: Decimal, $sucursalEmpresa: Decimal) {
            territorio {
              obtenerSegunFiltro(filtro: { exacto: { empresa_rut: $rutEmpresa, sucursal_codigo: $sucursalEmpresa } }) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  registros {
                    codigo
                    nombre
                  }
                }
              }
            }
          }
        `,
        variables: {
          rutEmpresa: this.rutEmpresa,
          sucursalEmpresa: this.sucursalEmpresa,
        },
        fetchPolicy: 'no-cache',
      },
      function (respuesta) {
        self.listaTerritoriosDireccion = respuesta.data.territorio.obtenerSegunFiltro.respuesta.registros;
        self.optionsTerritorioDireccion = [];
        let sel: any;
        self.listaTerritoriosDireccion.forEach((element) => {
          sel = { value: element.codigo, label: element.nombre };
          self.optionsTerritorioDireccion.push(sel);
        });
      }
    );
  }

  obtenerDatosRuta() {
    const self = this; // this is unused

    this.client.query(
      {
        query: gql`
          query ($rutEmpresa: Decimal, $sucursalEmpresa: Decimal) {
            ruta {
              obtenerSegunFiltro(filtro: { exacto: { empresa_rut: $rutEmpresa, sucursal_codigo: $sucursalEmpresa, tipobusqueda: 1 } }) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  registros {
                    codigo
                    descripcion
                  }
                }
              }
            }
          }
        `,
        variables: {
          rutEmpresa: this.rutEmpresa,
          sucursalEmpresa: this.sucursalEmpresa,
        },
        fetchPolicy: 'no-cache',
      },
      function (respuesta) {
        self.listaRutasDireccion = respuesta.data.ruta.obtenerSegunFiltro.respuesta.registros;
        self.optionsRutaDireccion = [];
        let sel: any;
        self.listaRutasDireccion.forEach((element) => {
          sel = { value: element.codigo.trim(), label: element.descripcion };
          self.optionsRutaDireccion.push(sel);
        });
      }
    );
  }

  createForms() {
    return new FormGroup({
      showCoordenadas: new FormControl({ value: false }),
      estadoDireccion: new FormControl({ value: true }),
      direccDesp: new FormControl({ value: false }),
      esCasaMatriz: new FormControl({ value: true }),
      region: new FormControl({ value: '' }),
      comuna: new FormControl({ value: '' }, [Validators.required]),
      nombre: new FormControl({ value: '' }, [Validators.required, Validators.minLength(5), Validators.maxLength(100)]),
      direccion: new FormControl({ value: '' }, []),
      direccNueva: new FormControl({ value: '' }),
      usaDireccionDespacho: new FormControl({ value: true }),
      direccionDespacho: new FormControl({ value: '' }),
      contacto: new FormControl({ value: '' }, []),
      localidad: new FormControl({ value: '' }),
      fijo: new FormControl({ value: '' }),
      territorio: new FormControl({ value: '' }, [Validators.required]),
      movil: new FormControl({ value: '' }),
      ruta: new FormControl({ value: '' }, [Validators.required]),
      email: new FormControl({ value: '' }, [Validators.email]),
      showEmpresaHeredada: new FormControl({ value: true }),
      latitud: new FormControl({ value: '' }, [Validators.required]),
      longitud: new FormControl({ value: '' }, [Validators.required]),
      referencias: new FormControl('', [Validators.maxLength(160)]),
      facturarACasaMatriz: new FormControl({ value: this.RB_CASAMATRIZ_ }),
      buscarPor: new FormControl({ value: false }),
      direccionFormateada: new FormControl({ value: '' }),
      VendedorSel: new FormControl({ value: '' }),
      RubroSel: new FormControl({ value: '' }),
      secuencia: new FormControl({ value: 0 }),
      EmpresaAlteSel: new FormControl({ value: '' }),
    });
  }

  loadInitialMapsData() {
    // load Places Autocomplete
    this.mapsAPILoader.load().then(() => {
      this.setCurrentLocation();
      const countryRestrict = { country: 'cl' };

      this.geoCoder = new google.maps.Geocoder();

      // const autocomplete = new google.maps.places.Autocomplete(
      //   this.searchElementRef.nativeElement,
      //   {
      //     types: ['address'],
      //     componentRestrictions: countryRestrict,
      //   }
      // );
      const autocompleteEdita = new google.maps.places.Autocomplete(this.searchElementRefEdita.nativeElement, {
        types: ['address'],
        componentRestrictions: countryRestrict,
      });
      // autocomplete.setFields(['address_component']);

      // autocomplete.addListener('place_changed', () => {
      //   this.ngZone.run(() => {
      //     // get the place result
      //     const place: google.maps.places.PlaceResult = autocomplete.getPlace();

      //     // verify result
      //     if (place.geometry === undefined || place.geometry === null) {
      //       return;
      //     }

      //     // set latitude, longitude and zoom
      //     this.formAgregaDatosDirecciones
      //       .get('latitud')
      //       .setValue(place.geometry.location.lat());
      //     this.formAgregaDatosDirecciones
      //       .get('longitud')
      //       .setValue(place.geometry.location.lng());
      //     this.formAgregaDatosDirecciones
      //       .get('direccionFormateada')
      //       .setValue(place.formatted_address);
      //     this.formAgregaDatosDirecciones.get('direccion').setValue(place.name);
      //     this.latitude = place.geometry.location.lat();
      //     this.longitude = place.geometry.location.lng();
      //     this.zoom = 16;
      //     this.address = place.formatted_address;
      //     const comunaId: number = this.listaComunasFiltro.find(
      //       (ele) =>
      //         ele.nombre === place.address_components[2].long_name.toString()
      //     ).codigo;
      //     this.formAgregaDatosDirecciones.get('comuna').setValue(comunaId);
      //   });
      // });

      autocompleteEdita.addListener('place_changed', () => {
        this.ngZone.run(() => {
          // get the place result
          const place: google.maps.places.PlaceResult = autocompleteEdita.getPlace();
          // verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          // set latitude, longitude and zoom
          this.formDatosDirecciones.get('latitud').setValue(place.geometry.location.lat());
          this.formDatosDirecciones.get('longitud').setValue(place.geometry.location.lng());
          this.formDatosDirecciones.get('direccionFormateada').setValue(place.formatted_address);
          this.formDatosDirecciones.get('direccion').setValue(place.name);
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          this.zoom = 16;
          this.address = place.formatted_address;
          const comunaId = this.listaComunasFiltro.filter((ele) => ele.nombre === place.address_components[2].long_name.toUpperCase().trim());

          this.formDatosDirecciones.get('comuna').setValue(comunaId[0].codigo);
        });
      });
    });
    this.formChangesSubscriptions();
  }

  ShowCoordenadasLatLong({ checked }) {
    if (checked === true) {
      this.ShowLongLat = true;
      const a = this.formDatosDirecciones.get('direccion').value;
      this.formDatosDirecciones.get('direccNueva').setValue(a);
    } else {
      this.ShowLongLat = false;
      const a = this.formDatosDirecciones.get('direccNueva').value;
      this.formDatosDirecciones.get('direccion').setValue(a);
    }
    // Actualiza los validadores cada vez que cambia showLongLat
    this.toggleValidators();
  }

  toggleValidators(): void {
    if (this.ShowLongLat) {
      this.formDatosDirecciones.get('direccion').clearValidators();
      this.formDatosDirecciones.get('direccNueva').setValidators([Validators.required]);
    } else {
      this.formDatosDirecciones.get('direccion').setValidators([Validators.required]);
      this.formDatosDirecciones.get('direccNueva').clearValidators();
    }
    this.formDatosDirecciones.get('direccion').updateValueAndValidity();
    this.formDatosDirecciones.get('direccNueva').updateValueAndValidity();
  }

  private setCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.formDatosDirecciones.get('latitud').setValue(position.coords.latitude);
        this.formDatosDirecciones.get('longitud').setValue(position.coords.latitude);
        this.zoom = 16;
        this.getAddress(position.coords.latitude, position.coords.longitude);
      });
    }
  }

  // getAddress(latitude, longitude) {
  //   this.geoCoder.geocode({ location: { lat: latitude, lng: longitude } }, (results, status) => {
  //     // this.log(results);
  //     // this.log(status);
  //     if (status === 'OK') {
  //       if (results[0]) {
  //         this.zoom = 16;
  //         this.address = results[0].formatted_address;
  //         this.formDatosDirecciones.get('direccionFormateada').setValue(results[0].formatted_address);
  //         this.formDatosDirecciones.get('direccion').setValue(results[0].formatted_address.split(',')[0]);

  //         const comunaId = this.listaComunasFiltro.filter((ele) => ele.nombre === results[0].address_components[2].long_name.toUpperCase().trim());

  //         this.formDatosDirecciones.get('comuna').setValue(comunaId[0].codigo);
  //       } else {
  //         // window.alert(
  //         //   'No se encontraron resultados. Debe ingresarla manualmente.'
  //         // );
  //         this.toastService.info('No se encontraron resultados. Debe ingresarla manualmente.');
  //       }
  //     } else {
  //       // window.alert('Fallo de GeoCoder: ' + status);
  //       // this.toastService.error('Fallo de GeoCoder: ' + status);
  //       if (status == google.maps.GeocoderStatus.OVER_QUERY_LIMIT) {
  //         setTimeout(() => 3000);
  //       }
  //     }
  //   });
  // }

  getAddress(latitud, longitud): void {
    const lat = Number(latitud);
    const lng = Number(longitud);
    const geocoder = new google.maps.Geocoder();
    const latlng = { lat: lat, lng: lng }; // Corrige las propiedades aquí
    geocoder.geocode({ location: latlng }, (results, status) => {
      if (status === 'OK') {
        if (results[0]) {
          this.zoom = 16;
          this.address = results[0].formatted_address;
          console.log(this.address);
          const addressComponents = results[0].address_components;
          const comuna = this.extractComuna(addressComponents);
          this.formDatosDirecciones.get('direccNueva').setValue(this.address.split(',')[0]);
          console.log(comuna);
          if (latitud != null && longitud != null && this.ShowLongLat == true) {
            const comunaId = this.listaComunasFiltro.filter((ele) => ele.nombre.trim() === comuna.trim());
            this.formDatosDirecciones.get('comuna').setValue(comunaId[0].codigo);
          }
        } else {
          this.toastService.info('No se encontraron resultados. Debe ingresarla manualmente.');
          console.log('No results found');
        }
      } else {
        console.log('Geocoder failed due to: ' + status);
      }
    });
  }

  extractComuna(addressComponents: google.maps.GeocoderAddressComponent[]): string | null {
    for (let component of addressComponents) {
      if (component.types.includes('locality')) {
        return component.long_name.toUpperCase(); // O long_name o short_name dependiendo de lo que necesites
      }
    }
    return null;
  }

  formChangesSubscriptions() {
    this.formDatosDirecciones
      .get('latitud')
      .valueChanges.pipe(filter(Boolean), debounceTime(1000))
      .subscribe((latitud: number) => {
        this.getAddress(latitud, this.formDatosDirecciones.get('longitud').value);
        this.latitude = latitud;
        this.EnableItem();
      });

    this.formDatosDirecciones
      .get('longitud')
      .valueChanges.pipe(filter(Boolean), debounceTime(1000))
      .subscribe((longitud: number) => {
        this.getAddress(this.formDatosDirecciones.get('latitud').value, longitud);
        this.longitude = longitud;
        this.EnableItem();
      });

    this.formDatosDirecciones
      .get('comuna')
      .valueChanges.pipe(filter(Boolean), debounceTime(1000))
      .subscribe((comuna: number) => {
        // this.getAddress(this.formDatosDirecciones.get("latitud").value, longitud);
        this.comunaCodigo = comuna;
        this.loadEmpesaAlterna();
      });
  }

  markerDragEnd($event: MouseEvent) {
    this.log($event);
    this.latitude = $event.coords.lat;
    this.longitude = $event.coords.lng;
    this.formDatosDirecciones.get('latitud').setValue($event.coords.lat);
    this.formDatosDirecciones.get('longitud').setValue($event.coords.lng);
    this.getAddress(this.latitude, this.longitude);
  }

  EnableItem() {
    const lat = this.formDatosDirecciones.get('latitud').value;
    const lng = this.formDatosDirecciones.get('longitud').value;
    this.getLocationPlace(lat, lng);
  }

  lastLocalitationLat: number = 0;
  lastLocalitationLong: number = 0;
  getLocationPlace(latitude: number, longitude: number) {
    this.lat = latitude;
    this.long = longitude;

    if (!latitude || !longitude) return;

    latitude = latitude;
    longitude = longitude;

    if (this.lastLocalitationLat !== latitude && this.lastLocalitationLong !== longitude) {
      this.lastLocalitationLat = latitude;
      this.lastLocalitationLong = longitude;

      this.geoCoder.geocode(
        { location: { lat: Number(this.lastLocalitationLat), lng: Number(this.lastLocalitationLong) } },
        (results, status) => {
          if (status === 'OK') {
            if (results[0]) {
              this.ngZone.run(() => {
                // verify result

                this.zoom = 16;
                this.latitude = Number(this.lastLocalitationLat);
                this.longitude = Number(this.lastLocalitationLong);
                this.address = results[0].formatted_address;
              });
            } else {
              // window.alert(
              //   'No se encontraron resultados. Debe ingresarla manualmente.'
              // );
              this.toastService.info('No se encontraron resultados. Debe ingresarla manualmente.');
            }
          } else {
            // window.alert('Fallo de GeoCoder: ' + status);
            // this.toastService.error("Fallo de GeoCoder: " + status);
            if (status == google.maps.GeocoderStatus.OVER_QUERY_LIMIT) {
              setTimeout(() => 3000);
            }
          }
        }
        // this.log(results);
        // this.log(status);
      );
    }
  }

  showModalModificarDtoDireccion(cliente: cliente_proveedor) {
    const self = this;
    this.rutCliente = cliente.rut;
    this.nombreCliente = cliente.nombre;
    this.rutClienteFormateado = this.validadores._enmascaraRut(String(this.rutCliente));
    this.filtraGrillaDirecciones(1);
    this.loadComboDirecciones();
    this.editarModalDtoDireccion.show();
    this.clientesService.rolOperacionPermitida(
      {
        rut_usu: self.rutUsuario,
        codgo_modulo: MANTENEDOR_CLIENTES_MODULO,
        cod_operacion: OP_EDICION_DIRECCIONES,
      },
      ({ mensajes }) => {
        self.puedeEditarDirecciones =
          mensajes && mensajes.length > 0 && mensajes[0].tipo === TipoMensaje.SUCCESS;
        if (self.puedeEditarDirecciones) {
          self.formDatosDirecciones.enable();
        } else {
          self.formDatosDirecciones.disable();
        }
      }
    );
  }

  filtraGrillaDirecciones(pageNumber: number) {
    this.log('buscar');
    const self = this; // this is unused
    this.paginationContext.CurrentPage = pageNumber;

    this.filtroDireccionNombre = this.filtroDireccionNombre === undefined ? '' : this.filtroDireccionNombre;
    this.filtroDireccionDireccion = this.filtroDireccionDireccion === undefined ? '' : this.filtroDireccionDireccion;

    this.client.query(
      {
        query: gql`
          query ($rutEmpresa: Decimal, $rutCliente: Decimal, $nombreDireccion: String, $direccionCompleta: String, $paginaActual: Int) {
            direccion {
              obtenerSegunFiltro(
                filtro: { exacto: { cliente_proveedor_rut: $rutCliente, empresa_rut: $rutEmpresa, direccion_completa: $direccionCompleta, nombre: $nombreDireccion } }
                paginaActual: $paginaActual
                cantidadRegistrosPorPagina: -1
              ) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    cliente_proveedor_rut
                    codigo
                    direccion_completa
                    comuna_codigo
                    es_principal
                    territorio_codigo
                    ruta_codigo
                    empresa_rut
                    fecha_creacion
                    nombre
                    nombre_contacto
                    codigo_direccion_despacho
                    usa_direccion_despacho
                    localidad
                    fono_fijo
                    fono_movil
                    email_contacto
                    latitud
                    longitud
                    referencias
                    facturar_a_casa_matriz
                    activo
                    secuencia
                    es_direccion_despacho
                    empresa_alterna_savory_idempalt
                  }
                }
              }
            }
          }
        `,
        fetchPolicy: 'no-cache',
        variables: {
          rutEmpresa: this.rutEmpresa,
          rutCliente: this.rutCliente,
          nombreDireccion: this.filtroDireccionNombre,
          direccionCompleta: this.filtroPrincipalDireccionCliente,
          paginaActual: this.paginaActualDirecciones,
        },
      },
      function (respuesta) {
        self.listaDireccionesAll = respuesta.data.direccion.obtenerSegunFiltro.respuesta.registros;
        self.paginationContext.RecordsCount = self.listaDireccionesAll.length; //totalRegistros
        self.paginationContext.PagesCount = Math.ceil(self.paginationContext.RecordsCount / self.paginationContext.RecordsByPage); //totalPaginas
        self.paginationContext.CurrentPage = pageNumber;

        const start = (self.paginationContext.CurrentPage - 1) * self.paginationContext.RecordsByPage;
        self.listaDirecciones = _.slice(self.listaDireccionesAll, start, start + self.paginationContext.RecordsByPage); // self.totalRegistrosDirecciones = respuesta.data.direccion.obtenerSegunFiltro.respuesta.totalRegistros;
        // self.totalPaginasDirecciones = respuesta.data.direccion.obtenerSegunFiltro.respuesta.totalPaginas;
        // if (self.totalPaginasDirecciones === 0) {
        //   self.totalPaginasDirecciones = 1;
        // }
      }
    );
  }

  showPage(pageNumber: number) {
    this.paginationContext.CurrentPage = pageNumber;
  }

  onPageChange(context: PaginationContext) {
    this.filtraGrillaDirecciones(context.RequestedPage);
  }

  loadComboDirecciones() {
    const self = this; // this is unused

    this.client.query(
      {
        query: gql`
          query ($rutEmpresa: Decimal, $rutCliente: Decimal) {
            direccion {
              obtenerSegunFiltro(filtro: { exacto: { cliente_proveedor_rut: $rutCliente, empresa_rut: $rutEmpresa, direccion_completa: "", nombre: "", activo: true } }) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo
                    nombre
                    direccion_completa
                    activo
                  }
                }
              }
            }
          }
        `,
        fetchPolicy: 'no-cache',
        variables: {
          rutEmpresa: this.rutEmpresa,
          rutCliente: this.rutCliente,
        },
      },
      function (respuesta) {
        self.listaDireccionesCombo = respuesta.data.direccion.obtenerSegunFiltro.respuesta.registros;
        self.optionsDireccion = [];
        let sel: any;
        if (self.listaDireccionesCombo.length > 0) {
          self.listaDireccionesCombo.forEach((element) => {
            console.log('muestrame el option', element);
            sel = { value: element.codigo, label: element.direccion_completa };
            self.optionsDireccion.push(sel);
          });
        } else {
          sel = { value: -1, label: '' };
          self.optionsDireccion.push(sel);
        }
      }
    );
  }

  showModalAgregarDireccion(mode: 'ADD' | 'EDIT' = 'EDIT') {
    this.log('showModalAgregarDireccion', mode);
    if (mode === 'ADD') {
      // Limpiar lista Vendedores
      this.listaClienteVendedorRubroIPT = [];
      this.listaClienteVendedorRubroIPTFixed = [];
    }

    this.formDatosDirecciones.get('RubroSel').setValue(1); // Set rubro HELADOS, por defecto

    this.agregarDireccion.show();
  }

  checkEmpresa({ checked }) {
    this.formDatosDirecciones.get('showEmpresaHeredada').setValue(checked);
  }

  toggleCheckbox($event) {
    const checked = $event.target.checked;
    console.log($event.target.checked);

    if (checked == true && this.listaDireccionesCombo.length > 0) {
      this.formDatosDirecciones.get('direccDesp').enable();

      this.checkbox1Checked = true;
    }

    if (checked == false && this.listaDireccionesCombo.length == 1) {
      this.formDatosDirecciones.get('direccDesp').disable();

      this.checkbox1Checked = false;
    }
  }

  showModalEditaDireccion(dir: direccion) {
    this.listaDireccionesCombo;

    console.log('muestrame los datos para agregar', dir);
    this.formDatosDirecciones.reset();
    this.direccionCliente = dir.codigo;

    if (this.optionsEmpresaAlterna.length < 1) {
      this.HidenEmpresaHeredada = false;
      this.formDatosDirecciones.get('showEmpresaHeredada').setValue(false);
    } else {
      this.HidenEmpresaHeredada = true;
      this.formDatosDirecciones.get('showEmpresaHeredada').setValue(true);
      this.formDatosDirecciones.get('EmpresaAlteSel').setValue(dir.empresa_alterna_savory_idempalt);
    }

    this.formDatosDirecciones.get('estadoDireccion').setValue(dir.activo);

    //*  SI HAY MAS DE 1 DIRECCION Y ESTAN ACTIVAS
    const listClientDirecc = this.listaDireccionesCombo.filter((x) => x.activo == true).length;
    if (this.listaDireccionesCombo.length > 1 && listClientDirecc > 1) {
      this.formDatosDirecciones.get('direccDesp').enable();
      this.formDatosDirecciones.get('direccDesp').setValue(dir.es_direccion_despacho);
    } else {
      this.formDatosDirecciones.get('direccDesp').disable();
      this.formDatosDirecciones.get('direccDesp').setValue(false);
    }

    this.formDatosDirecciones.get('esCasaMatriz').setValue(dir.es_principal);
    this.formDatosDirecciones.get('comuna').setValue(dir.comuna_codigo);
    this.formDatosDirecciones.get('nombre').setValue(dir.nombre);
    this.formDatosDirecciones.get('direccion').setValue(dir.direccion_completa);
    this.formDatosDirecciones.get('direccNueva').setValue(dir.direccion_completa);
    this.formDatosDirecciones.get('usaDireccionDespacho').setValue(dir.usa_direccion_despacho);

    this.manejadorDireccionDespacho(true);

    const codigoRuta = dir.ruta_codigo.trim();
    this.formDatosDirecciones.get('direccionDespacho').setValue(dir.codigo_direccion_despacho);
    this.formDatosDirecciones.get('contacto').setValue(dir.nombre_contacto);
    this.formDatosDirecciones.get('localidad').setValue(dir.localidad);
    this.formDatosDirecciones.get('fijo').setValue(dir.fono_fijo);
    this.formDatosDirecciones.get('territorio').setValue(dir.territorio_codigo);
    this.formDatosDirecciones.get('movil').setValue(dir.fono_movil);
    this.formDatosDirecciones.get('ruta').setValue(codigoRuta);
    this.formDatosDirecciones.get('email').setValue(dir.email_contacto);
    if (dir.latitud === 'null' || dir.latitud === null || dir.latitud === undefined) {
      dir.latitud = '';
    }
    if (dir.longitud === 'null' || dir.longitud === null || dir.longitud === undefined) {
      dir.longitud = '';
    }
    this.formDatosDirecciones.get('latitud').setValue(dir.latitud);
    this.formDatosDirecciones.get('longitud').setValue(dir.longitud);
    this.formDatosDirecciones.get('referencias').setValue(dir.referencias);
    this.formDatosDirecciones.get('facturarACasaMatriz').setValue(dir.facturar_a_casa_matriz);

    this.latitude = Number(dir.latitud);
    this.longitude = Number(dir.longitud);
    this.formDatosDirecciones.get('secuencia').setValue(dir.secuencia);

    // this.getAddress(Number(dir.latitud), Number(dir.longitud));

    this.showModalAgregarDireccion();

    this.listaClienteVendedorRubroIPT = [];
    this.listaIPTVendedorCliente = [];
    this.listaVendedorRubroCliente = [];
    this.comunaCodigo = dir.comuna_codigo;
    this.loadGrillaVendedores();
    this.loadEmpesaAlterna();
  }

  manejadorDireccionDespacho(edita: boolean) {
    if (Boolean(this.formDatosDirecciones.get('usaDireccionDespacho').value)) {
      this.formDatosDirecciones.get('direccionDespacho').reset();
      this.formDatosDirecciones.get('direccionDespacho').disable();
      if (this.direccionCliente !== -1) {
        this.formDatosDirecciones.get('direccionDespacho').setValue(this.direccionCliente);
      }
      this.formDatosDirecciones.get('direccionDespacho').setValidators([]);
    } else {
      if (this.listaDireccionesCombo.length <= 0) {
        // alert('No hay direcciones disponibles para seleccionar. Debe escoger esta misma dirección como dirección de despacho');
        this.toastService.warning('No hay direcciones disponibles para seleccionar. Debe escoger esta misma dirección como dirección de despacho');
        this.formDatosDirecciones.get('usaDireccionDespacho').setValue(true);
      } else {
        this.formDatosDirecciones.get('direccionDespacho').enable();

        this.formDatosDirecciones.get('direccionDespacho').reset();
        this.formDatosDirecciones.get('direccionDespacho').setValidators([Validators.required]);
      }
    }
  }

  loadGrillaVendedores() {
    this.log('loadGrillaVendedores');
    // listaClienteVendedorRubroIPT
    const self = this; // this is unused

    this.client.query(
      {
        query: gql`
          query ($rutEmpresa: Decimal, $sucursalCodigo: Decimal, $rutCliente: Decimal, $direccionCodigo: Decimal) {
            vendedor_rubro_cliente {
              obtenerSegunFiltroRubroeIPT(
                filtro: {
                  exacto: { rut_empresa: $rutEmpresa, sucursal_codigo: $sucursalCodigo, cliente_proveedor_rut: $rutCliente, direccion_codigo: $direccionCodigo, vendedor_codigo: -1, rubro_codigo: -1 }
                }
              ) {
                respuesta {
                  registros {
                    cliente_proveedor_rut
                    direccion_codigo
                    lunes
                    martes
                    miercoles
                    jueves
                    viernes
                    sabado
                    domingo
                    es_cobrador
                    nombreRubro
                    nombreVendedor
                    realiza_cobro_maquina
                    rubro_codigo
                    vendedor_codigo
                    listaUnidadNegocio
                  }
                }
              }
            }
          }
        `,
        variables: {
          rutEmpresa: this.rutEmpresa,
          sucursalCodigo: this.sucursalEmpresa,
          rutCliente: this.rutCliente,
          direccionCodigo: this.direccionCliente,
        },
        fetchPolicy: 'no-cache',
      },
      function (respuesta) {
        self.listaClienteVendedorRubroIPT = respuesta.data.vendedor_rubro_cliente.obtenerSegunFiltroRubroeIPT.respuesta.registros;
        self.listaClienteVendedorRubroIPT.map((item) => {
          item.unidad_negocio_codigo = item.listaUnidadNegocio;
        });
        self.setListaVendedoresFixed();
      }
    );
  }

  setListaVendedoresFixed() {
    let listaVendedores = [];
    let lastVendedorCodigo = null;

    const vendedorRubrosVisiblesIndex = this.getVendedorRubrosVisiblesIndex();

    _.orderBy(this.listaClienteVendedorRubroIPT, ['vendedor_codigo'], ['asc']).forEach((vendedor) => {
      // nuevo registro
      if (lastVendedorCodigo !== vendedor.vendedor_codigo) {
        lastVendedorCodigo = vendedor.vendedor_codigo;
        listaVendedores.push(vendedor);
        listaVendedores[listaVendedores.length - 1].rubros = [];
        listaVendedores[listaVendedores.length - 1].rubrosVisibles = false;
        listaVendedores[listaVendedores.length - 1].front_id = `vendedor_${vendedor.vendedor_codigo}`;
      }

      // add rubro al actual (último)
      listaVendedores[listaVendedores.length - 1].rubros.push({ nombreRubro: vendedor.nombreRubro, rubro_codigo: vendedor.rubro_codigo });
    });

    // Set cobrador
    let hasDefaultCobrador = false;
    for (let i = 0; i < this.listaClienteVendedorRubroIPT.length; i++) {
      if (this.listaClienteVendedorRubroIPT[i].es_cobrador) {
        const cobradorIndex: number = listaVendedores.findIndex((vendedor) => vendedor.vendedor_codigo === this.listaClienteVendedorRubroIPT[i].vendedor_codigo);
        listaVendedores[cobradorIndex].es_cobrador = true;
        hasDefaultCobrador = true;
        break;
      }
    }
    this.listaClienteVendedorRubroIPTFixed = listaVendedores;

    if (vendedorRubrosVisiblesIndex >= 0 && this.listaClienteVendedorRubroIPTFixed && this.listaClienteVendedorRubroIPTFixed.length > vendedorRubrosVisiblesIndex) {
      this.listaClienteVendedorRubroIPTFixed[vendedorRubrosVisiblesIndex].rubrosVisibles = true;
    }

    if (!hasDefaultCobrador) this.setCobradorByDefault();
  }

  showModalAgregaDireccion() {
    this.formDatosDirecciones.reset();
    this.direccionCliente = -1;
    this.showModalAgregarDireccion('ADD');
    this.listaClienteVendedorRubroIPT = [];
    this.listaIPTVendedorCliente = [];
    this.listaVendedorRubroCliente = [];
    this.listaVendedorUnidadNegocio = [];

    if (this.optionsEmpresaAlterna.length < 1) {
      this.HidenEmpresaHeredada = false;
      this.formDatosDirecciones.get('showEmpresaHeredada').setValue(false);
    } else {
      this.HidenEmpresaHeredada = true;
      this.formDatosDirecciones.get('showEmpresaHeredada').setValue(true);
    }

    this.formDatosDirecciones.get('EmpresaAlteSel').setValue(null);
    this.formDatosDirecciones.get('usaDireccionDespacho').setValue(true);
    this.formDatosDirecciones.get('direccionDespacho').disable();
    this.formDatosDirecciones.get('nombre').setValue(this.nombreCliente);
    this.formDatosDirecciones.get('facturarACasaMatriz').setValue(this.RB_CASAMATRIZ_);
  }

  eliminaVendedorRubro(rubroipt: any) {
    const { vendedor_codigo } = rubroipt;
    this.listaClienteVendedorRubroIPT = this.listaClienteVendedorRubroIPT.filter((vendedor) => vendedor.vendedor_codigo !== vendedor_codigo);
    this.setListaVendedoresFixed();
  }

  setCobradorByDefault() {
    if (!this.listaClienteVendedorRubroIPT) return;
    const cobradoresMatches = this.listaClienteVendedorRubroIPT.filter((vendedor) => vendedor.es_cobrador).length;
    if (cobradoresMatches === 0 && this.listaClienteVendedorRubroIPT.length > 0) this.listaClienteVendedorRubroIPT[0].es_cobrador = true;
  }

  agregaVendedorRubro() {
    if (
      this.formDatosDirecciones.get('VendedorSel').value === null //||
      // this.formDatosDirecciones.get("RubroSel").value === null
    ) {
      // alert('Debe escoger vendedor y rubro');
      // this.toastService.warning("Debe escoger vendedor y rubro");
      this.toastService.warning('Debe escoger vendedor');
      return;
    }
    // for (const item of this.listaClienteVendedorRubroIPT) {
    //   const arr = [item.rubro_codigo, item.nombreRubro];
    //   const idx = arr.indexOf(
    //     this.formDatosDirecciones.get("RubroSel").value
    //   );
    //   if (idx !== -1) {
    //     // alert('El rubro ya se encuentra ingresado');
    //     this.toastService.info("El rubro ya se encuentra ingresado");
    //     return;
    //   }
    // }

    this.obtenerRubrosPorVendedor(
      this.formDatosDirecciones.get('VendedorSel').value,
      (respuesta) => {
        this.log('success', respuesta);

        const cobradoresMatches = this.listaClienteVendedorRubroIPT.filter((vendedor) => vendedor.es_cobrador).length;

        let nombreVendedor = '';
        this.listaVendedor.forEach((element) => {
          if (element.codigo === this.formDatosDirecciones.get('VendedorSel').value) {
            nombreVendedor = element.nombre;
          }
        });

        const vendedor_codigo_agregado = Number(this.formDatosDirecciones.get('VendedorSel').value);
        const isNew = this.listaClienteVendedorRubroIPT.findIndex((v: cliente_vendedor_rubro_IPTFixed) => v.vendedor_codigo === vendedor_codigo_agregado) < 0;

        const vendedorRubro = respuesta.filter((r) => r.asignado);
        if (vendedorRubro.length === 0) {
          this.toastService.error('Vendedor no tiene rubros asignados');
          return;
        }
        vendedorRubro.forEach((rubroVendedor) => {
          /** INICIO Agregar uno **/
          const sel: cliente_vendedor_rubro_IPT = {
            cliente_proveedor_rut: this.rutCliente,
            direccion_codigo: this.direccionCliente,
            es_cobrador: cobradoresMatches > 0 ? false : true,
            lunes: false,
            martes: false,
            miercoles: false,
            jueves: false,
            viernes: false,
            sabado: false,
            domingo: false,
            rut_empresa: this.rutEmpresa,
            sucursal_codigo: this.sucursalEmpresa,
            vendedor_codigo: this.formDatosDirecciones.get('VendedorSel').value,
            rubro_codigo: rubroVendedor.rubro_codigo, //this.formDatosDirecciones.get("RubroSel").value,
            realiza_cobro_maquina: false,
            nombreVendedor,
            nombreRubro: rubroVendedor.rubro_nombre,
            unidad_negocio_codigo: [],
          };

          // this.listaRubros.forEach((element) => {
          //   if (
          //     element.codigo === this.formDatosDirecciones.get("RubroSel").value
          //   ) {
          //     sel.nombreRubro = element.descripcion;
          //   }
          // });

          this.listaClienteVendedorRubroIPT.push(sel);
        });
        /** FIN Agregar uno **/

        this.setListaVendedoresFixed();

        if (isNew) {
          this.hideAllRubrosPanel();
          this.listaClienteVendedorRubroIPTFixed[this.listaClienteVendedorRubroIPTFixed.length - 1].rubrosVisibles = true;
        } else {
          const indexVendedorRubrosDisplayed = this.listaClienteVendedorRubroIPTFixed.findIndex((v: cliente_vendedor_rubro_IPTFixed) => v.vendedor_codigo === vendedor_codigo_agregado);
          this.hideAllRubrosPanel();
          this.listaClienteVendedorRubroIPTFixed[indexVendedorRubrosDisplayed].rubrosVisibles = true;
        }
      },
      () => {
        this.log('error');
      }
    );
  }

  obtenerRubrosPorVendedor(vendedor_codigo: number, success: Function, error: Function) {
    const inputParams = {
      entidad: {
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalEmpresa,
        vendedor_codigo,
      },
    };

    this.log('inputParams', JSON.stringify(inputParams));

    this.rubroVendedorService.obtenerRubrosVendedor(inputParams, ({ respuesta, mensajes }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showErrors(mensajes);
        error();
        return;
      }

      success(respuesta);
    });
  }

  handleChangeCobrador(rubroipt: cliente_vendedor_rubro_IPTFixed) {
    const { vendedor_codigo } = rubroipt;

    // limpiar todos
    this.listaClienteVendedorRubroIPT.forEach((vendedor: cliente_vendedor_rubro_IPT) => {
      vendedor.es_cobrador = false;
    });

    const vendedorSeleccionadoIndex = this.listaClienteVendedorRubroIPT.findIndex((vendedor) => vendedor.vendedor_codigo === vendedor_codigo);
    this.listaClienteVendedorRubroIPT[vendedorSeleccionadoIndex].es_cobrador = true;

    this.setListaVendedoresFixed();
  }

  CambiaIPT(dia: string, rubroipt: any, index: any) {
    const { vendedor_codigo } = rubroipt;
    this.listaClienteVendedorRubroIPT.forEach((vendedor: cliente_vendedor_rubro_IPT) => {
      if (vendedor.vendedor_codigo === vendedor_codigo) {
        // vendedor.es_cobrador = false;
        vendedor[dia] = !vendedor[dia];
      }
    });
    // this.log('dia', dia, 'rubroipt', rubroipt, 'index', index, this.listaClienteVendedorRubroIPT)

    this.setListaVendedoresFixed();
  }

  onChangeForAddVendedor({ checked }) {
    this.disableAddVendedor = checked;
  }

  GrabarDireccion() {
    if (this.formDatosDirecciones.get('latitud').value === null || this.formDatosDirecciones.get('latitud').value === undefined || this.formDatosDirecciones.get('latitud').value === 'null') {
      this.formDatosDirecciones.get('latitud').setValue('');
      return;
    }
    if (this.formDatosDirecciones.get('longitud').value === null || this.formDatosDirecciones.get('longitud').value === undefined || this.formDatosDirecciones.get('longitud').value === 'null') {
      this.formDatosDirecciones.get('longitud').setValue('');
      return;
    }

    if (!this.formDatosDirecciones.get('latitud').valid || !this.formDatosDirecciones.get('longitud').valid) {
      return;
    }
    let tieneCobrador = false;
    this.listaIPTVendedorCliente = [];
    this.listaVendedorRubroCliente = [];

    const despacho = this.formDatosDirecciones.get('direccDesp').value;
    if (despacho === true) {
      //No es necesario agregar el vendedor
      // this.listaClienteVendedorRubroIPT = null;
      if (this.listaClienteVendedorRubroIPT.length > 0) {
        for (let i = 0; i < this.listaClienteVendedorRubroIPT.length; i++) {
          if (
            !this.listaClienteVendedorRubroIPT[i].lunes &&
            !this.listaClienteVendedorRubroIPT[i].martes &&
            !this.listaClienteVendedorRubroIPT[i].miercoles &&
            !this.listaClienteVendedorRubroIPT[i].jueves &&
            !this.listaClienteVendedorRubroIPT[i].viernes &&
            !this.listaClienteVendedorRubroIPT[i].sabado &&
            !this.listaClienteVendedorRubroIPT[i].domingo
          ) {
            // alert(
            //   'El IPT del vendedor ' + this.listaClienteVendedorRubroIPT[i].nombreVendedor + ' no está asignado'
            // );
            this.toastService.warning('El IPT del vendedor ' + this.listaClienteVendedorRubroIPT[i].nombreVendedor + ' no está asignado');
            // this.showModalAgregarDireccion();
            return false;
          }
          // if (element.es_cobrador) {
          //   tieneCobrador = true;
          // }
        }

        const cobradoresMatches = this.listaClienteVendedorRubroIPT.filter((vendedor) => vendedor.es_cobrador).length;
        tieneCobrador = cobradoresMatches > 0;
        if (!tieneCobrador) {
          // alert('No se ha asignado ningún vendedor como cobrador.');
          this.toastService.warning('No se ha asignado ningún vendedor como cobrador.');
          // this.showModalAgregarDireccion();
          return false;
        }

        const selectEmp = this.formDatosDirecciones.get('EmpresaAlteSel').value;
        const ShowEmp = this.formDatosDirecciones.get('showEmpresaHeredada').value;

        if (ShowEmp == true && selectEmp == null) {
          this.toastService.warning('No se ha asignado ninguna empresa destino.');
          return false;
        }

        this.listaClienteVendedorRubroIPT.forEach((element) => {
          let itemvrc: vendedor_rubro_cliente;
          let itemiptvc: ipt_vendedor_cliente;
          itemvrc = {
            rubro_codigo: element.rubro_codigo,
            cliente_proveedor_rut: element.cliente_proveedor_rut,
            direccion_codigo: element.direccion_codigo,
            realiza_cobro_maquina: element.realiza_cobro_maquina,
            rut_empresa: this.rutEmpresa,
            sucursal_codigo: this.sucursalEmpresa,
            vendedor_codigo: element.vendedor_codigo,
          };
          this.listaVendedorRubroCliente.push(itemvrc);
          itemiptvc = {
            cliente_proveedor_rut: element.cliente_proveedor_rut,
            direccion_codigo: element.direccion_codigo,
            lunes: element.lunes,
            martes: element.martes,
            miercoles: element.miercoles,
            jueves: element.jueves,
            viernes: element.viernes,
            sabado: element.sabado,
            domingo: element.domingo,
            empresa_rut: this.rutEmpresa,
            es_cobrador: element.es_cobrador,
            fecha_actualizacion: new Date(),
            fecha_registro: new Date(),
            vendedor_codigo: element.vendedor_codigo,
            listaUnidadNegocio: element.unidad_negocio_codigo,
          };
          this.listaIPTVendedorCliente.push(itemiptvc);
        });
      } else {
        this.listaClienteVendedorRubroIPT = null;
      }
    } else {
      if (this.listaClienteVendedorRubroIPT === null) {
        // alert(
        //   'Debe seleccionar algún vendedor y rubro para este cliente/dirección'
        // );
        this.toastService.warning('Debe seleccionar algún vendedor y rubro para este cliente/dirección');
        this.showModalAgregarDireccion();
        return false;
      }

      // NO ES OBLIGATORIO GUARDAR EL VENDEDOR - Inicio Se comenta codigo
      if (this.listaClienteVendedorRubroIPT.length === 0) {
        this.toastService.warning('Debe seleccionar algún vendedor y rubro para este cliente/dirección');
        this.showModalAgregarDireccion();
        return false;
      }
      // NO ES OBLIGATORIO GUARDAR EL VENDEDOR - Fin comentario

      for (let i = 0; i < this.listaClienteVendedorRubroIPT.length; i++) {
        if (
          !this.listaClienteVendedorRubroIPT[i].lunes &&
          !this.listaClienteVendedorRubroIPT[i].martes &&
          !this.listaClienteVendedorRubroIPT[i].miercoles &&
          !this.listaClienteVendedorRubroIPT[i].jueves &&
          !this.listaClienteVendedorRubroIPT[i].viernes &&
          !this.listaClienteVendedorRubroIPT[i].sabado &&
          !this.listaClienteVendedorRubroIPT[i].domingo
        ) {
          // alert(
          //   'El IPT del vendedor ' + this.listaClienteVendedorRubroIPT[i].nombreVendedor + ' no está asignado'
          // );
          this.toastService.warning('El IPT del vendedor ' + this.listaClienteVendedorRubroIPT[i].nombreVendedor + ' no está asignado');
          // this.showModalAgregarDireccion();
          return false;
        }
        // if (element.es_cobrador) {
        //   tieneCobrador = true;
        // }
      }

      const cobradoresMatches = this.listaClienteVendedorRubroIPT.filter((vendedor) => vendedor.es_cobrador).length;
      tieneCobrador = cobradoresMatches > 0;
      if (!tieneCobrador) {
        // alert('No se ha asignado ningún vendedor como cobrador.');
        this.toastService.warning('No se ha asignado ningún vendedor como cobrador.');
        // this.showModalAgregarDireccion();
        return false;
      }

      const selectEmp = this.formDatosDirecciones.get('EmpresaAlteSel').value;
      const ShowEmp = this.formDatosDirecciones.get('showEmpresaHeredada').value;

      if (ShowEmp == true && selectEmp == null) {
        this.toastService.warning('No se ha asignado ninguna empresa destino.');
        return false;
      }

      this.listaClienteVendedorRubroIPT.forEach((element) => {
        let itemvrc: vendedor_rubro_cliente;
        let itemiptvc: ipt_vendedor_cliente;
        itemvrc = {
          rubro_codigo: element.rubro_codigo,
          cliente_proveedor_rut: element.cliente_proveedor_rut,
          direccion_codigo: element.direccion_codigo,
          realiza_cobro_maquina: element.realiza_cobro_maquina,
          rut_empresa: this.rutEmpresa,
          sucursal_codigo: this.sucursalEmpresa,
          vendedor_codigo: element.vendedor_codigo,
        };
        this.listaVendedorRubroCliente.push(itemvrc);
        itemiptvc = {
          cliente_proveedor_rut: element.cliente_proveedor_rut,
          direccion_codigo: element.direccion_codigo,
          lunes: element.lunes,
          martes: element.martes,
          miercoles: element.miercoles,
          jueves: element.jueves,
          viernes: element.viernes,
          sabado: element.sabado,
          domingo: element.domingo,
          empresa_rut: this.rutEmpresa,
          es_cobrador: element.es_cobrador,
          fecha_actualizacion: new Date(),
          fecha_registro: new Date(),
          vendedor_codigo: element.vendedor_codigo,
          listaUnidadNegocio: element.unidad_negocio_codigo,
        };
        this.listaIPTVendedorCliente.push(itemiptvc);
      });
    }
    const codigoRuta = this.modificarCodigoRuta();
    this.formDatosDirecciones.get('ruta').setValue(codigoRuta);

    this.itemDireccion = {
      activo: this.formDatosDirecciones.get('estadoDireccion').value,
      es_direccion_despacho: this.formDatosDirecciones.get('direccDesp').value,
      cliente_proveedor_rut: this.rutCliente,
      codigo: this.direccionCliente,
      codigo_direccion_despacho: this.formDatosDirecciones.get('direccionDespacho').value,
      comuna_codigo: this.formDatosDirecciones.get('comuna').value,
      direccion_completa: this.ShowLongLat == false ? this.formDatosDirecciones.get('direccion').value : this.formDatosDirecciones.get('direccNueva').value,
      email_contacto: this.formDatosDirecciones.get('email').value,
      empresa_rut: this.rutEmpresa,
      es_principal: this.formDatosDirecciones.get('esCasaMatriz').value,
      facturar_a_casa_matriz: this.formDatosDirecciones.get('facturarACasaMatriz').value,
      fecha_creacion: new Date(),
      fono_fijo: this.formDatosDirecciones.get('fijo').value,
      fono_movil: this.formDatosDirecciones.get('movil').value,
      latitud: String(this.formDatosDirecciones.get('latitud').value),
      longitud: String(this.formDatosDirecciones.get('longitud').value),
      localidad: this.formDatosDirecciones.get('localidad').value,
      nombre: this.formDatosDirecciones.get('nombre').value,
      nombre_contacto: this.formDatosDirecciones.get('contacto').value,
      referencias: this.formDatosDirecciones.get('referencias').value,
      ruta_codigo: this.formDatosDirecciones.get('ruta').value,
      territorio_codigo: this.formDatosDirecciones.get('territorio').value,
      usa_direccion_despacho: this.formDatosDirecciones.get('usaDireccionDespacho').value,
      secuencia: this.formDatosDirecciones.get('secuencia').value,
      empresa_alterna_savory_idempalt: this.formDatosDirecciones.get('EmpresaAlteSel').value,
      // 0: el backend hereda la condición de pago de la casa matriz u otra dirección del cliente
      condicion_pago_codigo: 0,
      rut_usuario: this.rutUsuario,
      codigoModulo: this.codigoModulo,
    };
    this.postClienteDatosDireccion(this.itemDireccion, this.listaIPTVendedorCliente, this.listaVendedorRubroCliente, this.mode === 'ADD');
    this.onSuccess.emit();
  }
  // GUARDO EL CODIGO DE LA RUTA TAL COMO ESTA EN LA BASE DE DATOS
  modificarCodigoRuta(): string {
    const codigoRuta = this.formDatosDirecciones.get('ruta').value;
    const ruta = this.listaRutasDireccion.find(x => {
      const codigoTrim = x.codigo.trim();
      return codigoTrim === codigoRuta;
    });
    return ruta.codigo;
  }

  postClienteDatosDireccion(dir: direccion, ipt: ipt_vendedor_cliente[], rub: vendedor_rubro_cliente[], esClienteNuevo: boolean) {
    const self = this;
    this.clientesService.rolOperacionPermitida(
      {
        rut_usu: self.rutUsuario,
        codgo_modulo: MANTENEDOR_CLIENTES_MODULO,
        cod_operacion: OP_EDICION_DIRECCIONES,
      },
      ({ mensajes }) => {
        if (!mensajes || mensajes.length === 0 || mensajes[0].tipo !== TipoMensaje.SUCCESS) {
          self.messageRendererService.showErrors(mensajes);
          return;
        }
        self.ejecutarPostClienteDatosDireccion(dir, ipt, rub, esClienteNuevo);
      }
    );
  }

  private ejecutarPostClienteDatosDireccion(dir: direccion, ipt: ipt_vendedor_cliente[], rub: vendedor_rubro_cliente[], esClienteNuevo: boolean) {
    const self = this;
    const bodyx = dir;
    this.client.mutate(
      {
        mutation: gql`
          mutation ($entidad: direccionInputType) {
            direccion {
              guardar(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  codigo
                  nombre
                }
              }
            }
          }
        `,
        variables: {
          entidad: bodyx,
        },
      },
      function (respuesta) {
        if (respuesta.data.direccion.guardar.respuesta != null) {
          self.direccionCliente = respuesta.data.direccion.guardar.respuesta.codigo;
          self.postVendedorRubroeIPT(self.listaVendedorRubroCliente, self.listaIPTVendedorCliente);
          // alert("Registro grabado");
          // self.agregarDireccion.hide();
        } else {
          // alert(respuesta.data.direccion.guardar.mensajes[0].texto);
          self.messageRendererService.showErrors(respuesta.data.direccion.guardar.mensajes);
        }
        // setTimeout(() => self.filtraGrillaDirecciones(), 1000);
        // self.direccionCliente = -1;
      }
    );
  }

  postVendedorRubroeIPT(rub: vendedor_rubro_cliente[], ipt: ipt_vendedor_cliente[]) {
    const self = this;

    rub.forEach(function (item) {
      item.direccion_codigo = self.direccionCliente;
    });
    ipt.forEach(function (item) {
      item.direccion_codigo = self.direccionCliente;
      item.rut_usuario = self.rutUsuario;
      item.codigo_modulo = self.codigoModulo;
      item.moduloGrabacion = 2;
    });

    this.client.mutate(
      {
        mutation: gql`
          mutation (
            $entidadvrc: vendedor_rubro_clienteListaInputType
            $entidadipt: ipt_vendedor_clienteListaInputType
            $rutEmpresa: Decimal
            $sucursalEmpresa: Decimal
            $rutCliente: Decimal
            $direccionCodigo: Decimal
          ) {
            vendedor_rubro_cliente {
              guardarLista(entidad: $entidadvrc, rutEmpresa: $rutEmpresa, sucursalEmpresa: $sucursalEmpresa, rutCliente: $rutCliente, direccionCodigo: $direccionCodigo) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
              }
            }
            ipt_vendedor_cliente {
              guardarLista(entidad: $entidadipt, rutEmpresa: $rutEmpresa, rutCliente: $rutCliente, direccionCodigo: $direccionCodigo) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
              }
            }
          }
        `,
        variables: {
          entidadvrc: { obj: rub },
          entidadipt: { obj: ipt },
          rutEmpresa: Number(this.rutEmpresa),
          sucursalEmpresa: Number(this.sucursalEmpresa),
          rutCliente: Number(this.rutCliente),
          direccionCodigo: Number(this.direccionCliente),
        },
      },
      function (respuesta) {
        const mensajeVRC = respuesta.data.vendedor_rubro_cliente.guardarLista.mensajes;
        const mensajeIPT = respuesta.data.ipt_vendedor_cliente.guardarLista.mensajes;

        if (mensajeVRC.find((element) => element.tipo === 'SUCCESS') === undefined || mensajeIPT.find((element) => element.tipo === 'SUCCESS') === undefined) {
          if (mensajeVRC.find((element) => element.tipo === 'SUCCESS') === undefined) {
            // alert('Error al grabar rubros/vendedores. Error devuelto' + mensajeVRC[0].texto);
            self.toastService.error('Error al grabar rubros/vendedores. Error devuelto' + mensajeVRC[0].texto);
          }
          if (mensajeIPT.find((element) => element.tipo === 'SUCCESS') === undefined) {
            // alert('Error al grabar rubros/vendedores. Error devuelto' + mensajeIPT[0].texto);
            self.toastService.error('Error al grabar rubros/vendedores. Error devuelto' + mensajeIPT[0].texto);
          }
        } else {
          // alert('Registro grabado');
          self.toastService.success('Registro grabado');
          self.agregarDireccion.hide();
          self.loadComboDirecciones();
          self.filtraGrillaDirecciones(1);
          self.direccionCliente = -1;
        }
      }
    );
  }

  verRubros(rubroipt, i) {
    const vendedorRubrosVisiblesIndex = this.getVendedorRubrosVisiblesIndex();
    const vendedorSeleccionadoIndex = this.listaClienteVendedorRubroIPTFixed.findIndex((vendedor: cliente_vendedor_rubro_IPTFixed) => vendedor.vendedor_codigo === rubroipt.vendedor_codigo);
    this.hideAllRubrosPanel();

    if (vendedorRubrosVisiblesIndex !== vendedorSeleccionadoIndex) this.listaClienteVendedorRubroIPTFixed[vendedorSeleccionadoIndex].rubrosVisibles = true;
  }

  getVendedorRubrosVisiblesIndex() {
    return this.listaClienteVendedorRubroIPTFixed ? this.listaClienteVendedorRubroIPTFixed.findIndex((vendedor: cliente_vendedor_rubro_IPTFixed) => vendedor.rubrosVisibles) : -1;
  }

  hideAllRubrosPanel() {
    this.listaClienteVendedorRubroIPTFixed.forEach((vendedor: cliente_vendedor_rubro_IPTFixed) => {
      vendedor.rubrosVisibles = false;
    });
  }

  agregarEditarDireccion() {
    if (!this.validateUnidadNegocioCabecera()) {
      this.showMessageSeleccionUnidadNegocio();
      return;
    }
    this.GrabarDireccion();
  }

  validateUnidadNegocioCabecera(): boolean {
    if (!this.permiteUnidadNegocio) return true;
    let cantUnidadNegocio = 0;
    this.log(`agregar producto`, JSON.stringify(this.listaClienteVendedorRubroIPTFixed));

    if (this.formDatosDirecciones.get('direccDesp').value == true) {
      return true;
    } else {
      if (this.listaClienteVendedorRubroIPTFixed.length > 0) {
        this.listaClienteVendedorRubroIPTFixed.forEach((v) => {
          if (v.unidad_negocio_codigo.length > 0) {
            cantUnidadNegocio = cantUnidadNegocio + v.unidad_negocio_codigo.length;
          }
        });
      } else {
        return false;
      }
    }

    if (this.optionsUnidadesDeNegocio.length === cantUnidadNegocio) {
      return true;
    }
    // const { unidad_negocio_codigo } = this.cabeceraComponent.getHeaderData()
    //return !!unidad_negocio_codigo
  }

  showMessageSeleccionUnidadNegocio(): void {
    this.toastService.warning('Seleccione unidad de negocio');
  }
  // eliminaRubroAssigned(rubroipt: cliente_vendedor_rubro_IPTFixed, rubroEliminado: any) {
  //   this.listaClienteVendedorRubroIPT = this.listaClienteVendedorRubroIPT.filter(vendedor => !(vendedor.vendedor_codigo === rubroipt.vendedor_codigo && vendedor.rubro_codigo === rubroEliminado.rubro_codigo))
  //   this.setListaVendedoresFixed()
  // }

  unidadNegocioChange(rubroipt, newUnidadNegocio) {
    console.log(rubroipt);
    rubroipt.unidad_negocio_codigo = newUnidadNegocio;

    // entra en el selectALL
    if (newUnidadNegocio.length == 2) {
      let element: number = 0;
      this.listaClienteVendedorRubroIPT.forEach((v) => {
        console.log('MUESTRAME V ', v);
        const banderaGuardado = v.unidad_negocio_codigo;
        console.log(banderaGuardado);
        if (v.vendedor_codigo == rubroipt.vendedor_codigo) {
          v.unidad_negocio_codigo = newUnidadNegocio;
        }

        if (v.vendedor_codigo != rubroipt.vendedor_codigo && newUnidadNegocio.some((element) => v.unidad_negocio_codigo.includes(element))) {
          newUnidadNegocio.forEach((y) => {
            if (newUnidadNegocio.length > 0) {
              console.log('MUESTRAME V1 ', v);

              if (v.unidad_negocio_codigo.length > 0) {
                console.log('MUESTRAME V2 ', v);

                for (let index = 0; index < v.unidad_negocio_codigo.length; index++) {
                  element = v.unidad_negocio_codigo[index];
                  if (newUnidadNegocio.includes(element)) {
                    // Si se encuentra el elemento, elimínalo con splice
                    // x.unidad_negocio_codigo = x.unidad_negocio_codigo.splice(index, 1);
                    v.unidad_negocio_codigo = v.unidad_negocio_codigo.filter((option) => option !== y);

                    // this.log(x.unidad_negocio_codigo, newUnidadNegocio)
                  }
                }
              }
            }
          });
        }
      });
      //   const { vendedor_codigo, unidad_negocio_codigo } = rubroipt;
      //   let element: number = 0;
      //   this.listaClienteVendedorRubroIPT.forEach(x => {
      //     if (x.vendedor_codigo == vendedor_codigo) {
      //       x.unidad_negocio_codigo = newUnidadNegocio
      //     } else {
      //       newUnidadNegocio.forEach(y => {
      //         if (newUnidadNegocio.length > 0) {
      //           for (let index = 0; index < x.unidad_negocio_codigo.length; index++) {
      //             element = x.unidad_negocio_codigo[index];
      //             if (newUnidadNegocio.includes(element)) {
      //               let index = x.unidad_negocio_codigo.indexOf(element);
      //               // Si se encuentra el elemento, elimínalo con splice
      //               if (index !== -1) {
      //                 // x.unidad_negocio_codigo = x.unidad_negocio_codigo.splice(index, 1);
      //                 x.unidad_negocio_codigo = x.unidad_negocio_codigo.filter(option => option !== y);

      //               }
      //               // this.log(x.unidad_negocio_codigo, newUnidadNegocio)
      //             }
      //           }
      //         }
      //       })
      //     }
      //   })
      //   this.log(`InputParams`, JSON.stringify(this.listaClienteVendedorRubroIPT))
    }

    if (newUnidadNegocio.length == 1) {
      let element: number = 0;
      this.listaClienteVendedorRubroIPT.forEach((v) => {
        if (v.vendedor_codigo != rubroipt.vendedor_codigo) {
          newUnidadNegocio.forEach((y) => {
            if (newUnidadNegocio.length > 0) {
              for (let index = 0; index < v.unidad_negocio_codigo.length; index++) {
                element = v.unidad_negocio_codigo[index];
                if (newUnidadNegocio.includes(element)) {
                  // Si se encuentra el elemento, elimínalo con splice
                  // x.unidad_negocio_codigo = x.unidad_negocio_codigo.splice(index, 1);
                  v.unidad_negocio_codigo = v.unidad_negocio_codigo.filter((option) => option !== y);

                  // this.log(x.unidad_negocio_codigo, newUnidadNegocio)
                }
              }
            }
          });
        }
      });
    }
  }
}
